export const services = [
  {
    id: 1,
    title: 'Standard House Cleaning',
    description: 'Perfect for weekly, bi-weekly, or monthly upkeep. Includes dusting, sweeping, mopping, vacuuming, bathrooms, kitchen surfaces, trash removal, and general tidy-up.',
    image: 'https://images.unsplash.com/photo-1628177142898-93e36e4e3a50?w=800'
  },
  {
    id: 2,
    title: 'Deep / Initial Cleaning',
    description: 'Required initial cleaning for all new recurring clients. Includes baseboards, vents, light switches, extra scrubbing, and detail work in high-touch areas.',
    image: 'https://images.unsplash.com/photo-1585421514738-01798e348b17?w=800'
  },
  {
    id: 3,
    title: 'Move-In & Move-Out Cleaning',
    description: 'Top-to-bottom clean for empty homes. Includes baseboards, inside cabinets & drawers, deep bathroom/kitchen cleaning, and full home refresh.',
    image: 'https://images.unsplash.com/photo-1556912173-46c336c7fd55?w=800'
  },
  {
    id: 4,
    title: 'Office & Commercial Cleaning',
    description: 'Reliable cleaning for offices, suites, and small commercial spaces. Flexible evening/weekend scheduling available.',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800'
  },
  {
    id: 5,
    title: 'Post-Construction Cleaning',
    description: 'Removes dust, debris, and construction residue for newly built or renovated spaces.',
    image: 'https://images.unsplash.com/photo-1604709177225-055f99402ea3?w=800'
  },
  {
    id: 6,
    title: 'Hazardous / Hoarder / Bio-Risk Cleaning',
    description: 'Specialized cleanup for hoarding situations, heavy neglect, severe buildup, and bio-risk sanitation. All hazardous conditions must be disclosed before booking.',
    image: 'https://images.unsplash.com/photo-1581578949510-fa7315c4c350?w=800'
  }
];

export const addOns = [
  'Inside Refrigerator',
  'Inside Oven',
  'Inside Cabinets',
  'Baseboards',
  'Interior Windows',
  'Exterior Windows',
  'Stairs'
];

export const whyChooseUs = [
  'Licensed & Insured',
  'SWaM Certified',
  '20+ Years Combined Cleaning Experience',
  'Highly Trained, Background-Checked Cleaners',
  'Recurring Cleaning Discounts Available',
  'All Supplies Provided (Eco-Friendly Options Available)',
  '100% Satisfaction Guaranteed'
];

export const serviceAreas = [
  'Richmond',
  'Henrico',
  'Chesterfield',
  'Glen Allen',
  'Midlothian',
  'Petersburg',
  'Hopewell',
  'Hanover'
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Johnson',
    location: 'Richmond, VA',
    rating: 5,
    text: 'Custom Maids RVA transformed my home! Professional, thorough, and incredibly reliable. I recommend them to everyone!',
    date: '2024-12-15'
  },
  {
    id: 2,
    name: 'Michael Chen',
    location: 'Glen Allen, VA',
    rating: 5,
    text: 'Best cleaning service we\'ve used. They pay attention to every detail and are always on time. Worth every penny!',
    date: '2024-11-28'
  },
  {
    id: 3,
    name: 'Jennifer Martinez',
    location: 'Chesterfield, VA',
    rating: 5,
    text: 'Excellent service! The team is professional, trustworthy, and does an amazing job. Our home has never looked better.',
    date: '2024-11-10'
  }
];

export const faqs = [
  {
    id: 1,
    question: 'Do I need to be home during the cleaning?',
    answer: 'No — you do not need to be home. Many clients provide a code or key.'
  },
  {
    id: 2,
    question: 'Do you provide your own supplies?',
    answer: 'Yes, we bring all cleaning supplies and equipment to maintain consistent quality across every job. Eco-friendly options are available upon request.'
  },
  {
    id: 3,
    question: 'Do you offer recurring discounts?',
    answer: 'Yes — weekly, bi-weekly, and monthly clients receive discounted rates after the initial deep cleaning.'
  },
  {
    id: 4,
    question: 'Why is a first-time deep cleaning required?',
    answer: 'Every home has different needs, buildup, and starting conditions. The first cleaning ensures your recurring cleanings stay consistent and affordable.'
  },
  {
    id: 5,
    question: 'Are you licensed and insured?',
    answer: 'Yes — Custom Maids RVA is fully licensed, insured, and SWaM certified.'
  },
  {
    id: 6,
    question: 'What areas do you serve?',
    answer: 'Richmond, Henrico, Chesterfield, Glen Allen, Midlothian, Petersburg, Hopewell, Hanover, and surrounding counties.'
  }
];